import styled from 'styled-components';

import { VerticalHorizontalCenterColumnBlock } from '../../../../styled';

export const StatesWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  min-height: 250px;
`;

export const StatesTitle = styled.div`
  ${(p) => p.theme.typography.title2}
`;

export const StatesContent = styled.div`
  ${(p) => p.theme.typography.description}
`;
